/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BuSbuModel>>;
export function request(body: defs.basics.BuSbuRequestParamsDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/buSbu/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
